import { render, staticRenderFns } from "./abnormalReport.vue?vue&type=template&id=64e6fd65"
import script from "./abnormalReport.vue?vue&type=script&lang=js"
export * from "./abnormalReport.vue?vue&type=script&lang=js"
import style0 from "./abnormalReport.vue?vue&type=style&index=0&id=64e6fd65&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports